/**
 * Admin Interface Styled Components
 *
 * Global admin-level styled components.
 *
 * @since 1.0.0
 */

import styled from '@emotion/styled';

export const AdminContainer = styled.div`
  margin: 0;
  padding: 0;
`;
